import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import type { Role } from '@hch/shared';
import { homeRouteFor, useAuth } from '~/lib/auth';

/**
 * Garde de route.
 *
 * Rappel important pour la soutenance : cette garde est une commodite d'interface,
 * PAS un mecanisme de securite. Elle evite d'afficher un ecran vide a un
 * utilisateur qui n'y a pas droit. La securite reelle est cote API — le
 * cloisonnement est applique dans les requetes SQL, et masquer un bouton dans le
 * navigateur ne protege rien.
 */
export function RoleGuard({ allow }: { allow: Role[] }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center" role="status">
        <Loader2 className="size-6 animate-spin text-muted-foreground" aria-hidden />
        <span className="sr-only">Verification de la session…</span>
      </div>
    );
  }

  if (!user) {
    // `state.from` permet de revenir a la page demandee apres connexion.
    return <Navigate to="/connexion" replace state={{ from: location.pathname }} />;
  }

  if (!allow.includes(user.role)) {
    return <Navigate to={homeRouteFor(user.role)} replace />;
  }

  return <Outlet />;
}
